import Layout from '../components/layout/Layout';

const PrivacyPage = () => {
  return (
    <Layout>
      <div className="py-10">
        <div className="container-custom">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Política de Privacidad</h1>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
            Última actualización: {new Date().toLocaleDateString()}
          </p>

          <div className="mt-6 space-y-6 text-gray-700 dark:text-gray-300 leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">1. Alcance</h2>
              <p className="mt-2 text-sm">
                Esta Política de Privacidad describe cómo Illustra recopila, utiliza y protege la información cuando usás la
                plataforma. Al utilizar Illustra, aceptás las prácticas descritas en este documento.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">2. Información que recopilamos</h2>
              <ul className="mt-3 space-y-2 text-sm">
                <li>
                  - <strong>Cuenta</strong>: email, identificadores de autenticación y datos básicos de perfil (nombre/usuario,
                  foto, banner, bio).
                </li>
                <li>
                  - <strong>Contenido</strong>: publicaciones, comentarios, likes, servicios, series y episodios que crees o
                  compartas.
                </li>
                <li>
                  - <strong>Mensajería</strong>: mensajes y adjuntos intercambiados en chats vinculados a órdenes.
                </li>
                <li>
                  - <strong>Uso y configuración</strong>: preferencias como modo oscuro y parámetros necesarios para operar la
                  sesión.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">3. Cómo usamos tu información</h2>
              <ul className="mt-3 space-y-2 text-sm">
                <li>- Para proveer funciones principales: perfil, feed, búsqueda, servicios, series, chat y notificaciones.</li>
                <li>- Para mejorar estabilidad, seguridad y prevenir abuso.</li>
                <li>- Para responder consultas y soporte.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">4. Base de tratamiento</h2>
              <p className="mt-2 text-sm">
                Tratamos tus datos para ejecutar el servicio que solicitás al usar la plataforma (prestación del servicio), y para
                cumplir obligaciones de seguridad, prevención de fraude y mantenimiento. Si en el futuro se incorporan herramientas
                opcionales (p. ej. analítica), se informará y/o solicitará el consentimiento cuando corresponda.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">5. Compartición con terceros</h2>
              <p className="mt-2 text-sm">
                Illustra utiliza proveedores de infraestructura para funcionar (por ejemplo, servicios de autenticación, base de
                datos y almacenamiento). No vendemos tus datos personales. Podemos compartir información cuando sea necesario para
                operar el servicio, cumplir la ley o proteger derechos y seguridad.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">6. Retención</h2>
              <p className="mt-2 text-sm">
                Conservamos la información mientras sea necesaria para brindarte el servicio y cumplir obligaciones legales o de
                seguridad. Si eliminás contenido o cerrás tu cuenta, se eliminarán o anonimizarán datos según corresponda, salvo
                retenciones obligatorias.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">7. Seguridad</h2>
              <p className="mt-2 text-sm">
                Implementamos medidas técnicas y organizativas razonables para proteger la información. Ningún sistema es 100%
                seguro: te recomendamos usar una contraseña robusta y mantener el acceso a tu email protegido.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">8. Tus derechos</h2>
              <p className="mt-2 text-sm">
                Podés solicitar acceso, rectificación, actualización o eliminación de datos personales, y realizar consultas sobre
                este documento. Para ello, escribinos a{' '}
                <a href="mailto:illustra.contacto@gmail.com" className="text-indigo-600 dark:text-indigo-400 hover:underline">
                  illustra.contacto@gmail.com
                </a>
                .
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">9. Cambios</h2>
              <p className="mt-2 text-sm">
                Podemos actualizar esta Política para reflejar cambios del producto o requisitos legales. La fecha de actualización
                se indicará al inicio.
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPage;

